exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-edit-form .add-tiem-btn[data-v-44d9c7af],.modal-edit-form .delete-tiem-btn[data-v-44d9c7af]{font-size:20px;font-weight:700;cursor:pointer;vertical-align:middle}.modal-edit-form .delete-tiem-btn[data-v-44d9c7af]{color:#f20}", ""]);

// exports
